import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { Col, ListGroup, Tab, Row } from "react-bootstrap";
import {
  MdClose,
  MdSearch,
  MdAccountCircle,
  MdOutbox,
  MdInbox,
  MdAddCall,
  MdSort,
} from "react-icons/md";
import { FaPhoneSlash, FaTag } from "react-icons/fa";

import CountBadge from "../shared/CountBadge";
import Loading from "../shared/Loading";
import Pagination from "./Pagination";
import Table from "../shared/Table";
import TableRow from "../shared/Row";
import TaskFieldFilter from "../shared/TaskFieldFilter";
import * as CONST from "../helpers/Constants";
import * as API from "../api";
import useDebounce from "./useDebounce";
import { Settings } from "../helpers/Contexts";

const Tasks = ({ state, dispatch }) => {
  const history = useHistory();
  const queryRef = React.useRef(state.query.string);
  const [searchTerm, setSearchTerm] = useState("");
  const [taskType, setTaskType] = useState(null);
  const [tagValues, setTagValues] = React.useState([]);
  const [tagFilterType, setTagFilterType] = React.useState('match_all');
  const tagsRef = React.useRef(state.searching ? tagValues : []);
  const [taskStatusFilter, setTaskStatusFilter] = React.useState("");
  const statusRef = React.useRef(taskStatusFilter);
  const [prevView, setPrevView] = useState("");
  const settings = React.useContext(Settings);

  useEffect(async () => {
    let queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let urlTagList = urlParams.getAll('tag');
    let urlTagFilterType = urlParams.getAll('tag_filter_type');
    let urlStatusFilter = urlParams.get('status');
    let searchTerm = urlParams.get('search');
    let urlTaskType = urlParams.get('task_type');
    let urlAppointmentRequestStatus = urlParams.get('appointment_request_status');
    let urlGeneralPatientRequestStatus = urlParams.get('general_patient_request_status');

    if (urlTagList) {
      if (urlTagFilterType) {
        setTagValues(urlTagList);
      }
      setTagValues(urlTagList);
      dispatch({ type: "set_current_sort_tags" });
    }

    if (searchTerm) {
      setSearchTerm(searchTerm);
    }

    if (urlTaskType) {
      let option = null;

      if (urlTaskType == 'appointment_request') {
        option = CONST.APPOINTMENT_FILTERS['options'].find((el) => el['appointment_request_status'] == urlAppointmentRequestStatus);
      } else if (urlTaskType == 'general_patient_request' && urlGeneralPatientRequestStatus) {
        option = CONST.OTHER_TASK_FILTERS.find((el) => el['task_type'] == 'general_patient_request' && el['general_patient_request_status'] == urlGeneralPatientRequestStatus);
      } else {
        option = CONST.OTHER_TASK_FILTERS.find((el) => el['task_type'] == urlTaskType);
      }
      setTaskType(option);
    }

    if (urlStatusFilter) {
      setTaskStatusFilter(urlStatusFilter);
    }

    state.isTaskSelected && dispatch({ type: "set_task_selected", payload: false });
    state.searching && setSearchTerm(state.query.string);
  }, []);

  const debouncedSearchTerm = useDebounce(searchTerm, 700);
  const debouncedTaskStatusFilter = useDebounce(taskStatusFilter, 700);
  const debouncedTagValues = useDebounce(tagValues, 700);
  const debouncedTagFilterType = useDebounce(tagFilterType, 700);


  // setTaskParamsUrl
  // this is executed everytime a tag is selected for filtering, or if the status filter is changed.
  // this allows us to filter the tasks from the URL params.
  function setTaskParamsUrl(tagValues, tagFilterType, taskStatusFilter, searchTerm, taskType, appointmentRequestStatus, generalPatientRequestStatus) {
    let url = `${ state.appName }/tasks?`

    if (tagValues.length > 0) {
      url += tagValues.map((el) => { return `tag=${ el }`; }).join('&');
    }

    if (taskStatusFilter != null) {
      url += `&status=${ taskStatusFilter }`;
    }

    if (tagFilterType != null) {
      url += `&tagFilterType=${ tagFilterType }`;
    }

    if (searchTerm != null) {
      url += `&search=${ searchTerm }`;
    }

    if (taskType) {
      url += `&task_type=${ taskType }`;
    }

    if (appointmentRequestStatus) {
      url += `&appointment_request_status=${ appointmentRequestStatus }`;
    }

    if (generalPatientRequestStatus) {
      url += `&general_patient_request_status=${ generalPatientRequestStatus }`;
    }

    window.history.pushState({}, "wellPORTAL Tasks", url);
  }
  // we can do search one of two ways.
  // first way is through the URL parameters. If the URL parameters has tag_list params,
  // we search using these URL parameters.
  // The other way is if the support agent uses the filter tag list box to filter at will.
  async function search() {
    let usingSearchQuery = searchTerm && searchTerm.length > 0;
    let usingTagList = tagValues && tagValues.length > 0;
    let filter = state.filter;
    const urlParams = new URLSearchParams(window.location.origin + filter.value);
    let appointmentRequestStatusParam = urlParams.get('appointment_request_status');
    let searchTaskType = taskType ? taskType['task_type'] : filter.task_type ||  null;
    if (usingTagList || usingSearchQuery) {
      dispatch({ type: "set_view_loading", payload: true });
      setTaskParamsUrl(tagValues, tagFilterType, taskStatusFilter, searchTerm,  searchTaskType);
      const response = await API.searchTasks({
        query: searchTerm,
        task_type: searchTaskType,
        tags: tagValues.join(","),
        status: taskStatusFilter,
        tagFilterType: tagFilterType,
        appointment_request_status: appointmentRequestStatusParam,
        page: state.query.currentPage ? state.query.currentPage : 1,
      });

      if (response) {
        dispatch({ type: "set_view_loading", payload: false });
      }
      return response;
    }
  }
  useEffect(
    async function () {
      if (
        debouncedSearchTerm.length > 0 ||
        debouncedTaskStatusFilter.length > 0 ||
        debouncedTagValues.length > 0
      ) {
        let response = await search();

        if (response) {
          dispatch({
            type: "set_tasks_query",
            payload: {
              tags: tagValues,
              searching: true,
              string: searchTerm,
              currentPage: state.query.currentPage ? state.query.currentPage : 1,
              tasks: response.tasks,
              tagsSearched: response.tags_searched,
              totalPages: response.total_pages_count,
              totalTasks: response.tasks_count,
            },
          });
        }
      } else if (taskType) {
        let response = await onFilterChange(taskType);
      }
    },
    [debouncedSearchTerm, debouncedTaskStatusFilter, debouncedTagValues, debouncedTagFilterType]
  );

  function taskClickHandler(id) {
    dispatch({ type: "set_loading", payload: true });
    dispatch({ type: "set_task_selected", payload: true });
    console.log("Tasks[taskClickHandler] fetching paused");
    history.push(`/${ state.appName }/tasks/item/${id}`);
  }

  const onFilterChange = async (taskFilterObj) => {
    dispatch({ type: "set_view_loading", payload: true });
    dispatch({ type: "set_active_view", payload: "" });
    setTaskType(taskFilterObj);
    searchTerm && setSearchTerm("");
    if (queryRef.current !== null) {
      queryRef.current.value = "";
    }
    dispatch({ type: "set_current_filter", payload: taskFilterObj });
    const tasks = await API.getFilteredTasks({
      url: taskFilterObj['value'],
      page: 1,
    });
    dispatch({ type: "set_current_tasks", payload: tasks });
    setTaskParamsUrl(
      tagValues,
      tagFilterType,
      null,
      null,
      taskFilterObj['task_type'],
      taskFilterObj['appointment_request_status'],
      taskFilterObj['general_patient_request_status']
    );
    setTimeout(() => {
      dispatch({ type: "set_view_loading", payload: false });
    }, 600);
  };

  async function onViewChange(view) {
    dispatch({ type: "set_view_loading", payload: true });
    searchTerm && setSearchTerm("");
    tagValues && setTagValues([]);
    taskType && setTaskType(null);

    if (queryRef.current !== null) {
      queryRef.current.value = "";
    }

    if (tagsRef.current !== null) {
      tagsRef.current.value = [];
    }

    dispatch({ type: "set_tags", payload: false });

    dispatch({ type: "set_active_view", payload: view });
    const tasks = await API.getTasksByView({ view: view, page: 1 });
    dispatch({ type: "set_current_tasks", payload: tasks });
  }

  const pageClickHandler = async (payload) => {
    dispatch({ type: "set_view_loading", payload: true });
    setTaskParamsUrl([], null, null, state.query.string, null);
    if (state.searching) {
      const response = await API.searchTasks({
        status: taskStatusFilter,
        tags: tagValues.join(","),
        tagFilterType: tagFilterType,
        query: searchTerm,
        page: payload
      });
      dispatch({
        type: "set_tasks_query",
        payload: {
          searching: true,
          string: searchTerm,
          currentPage: payload,
          tasks: response.tasks,
          totalPages: response.total_pages_count,
          totalTasks: response.tasks_count,
        },
      });
    }
    if (state.filter.value) {
      dispatch({ type: "set_current_page", payload });
      dispatch({
        type: "set_current_tasks",
        payload: await API.getFilteredTasks({
          url: state.filter.value,
          page: payload,
          assignee_support_group_id:
            state.settings.me.support_agent_type == "Admin"
              ? null
              : state.settings.me.support_group_id,
          assigner_support_group_id:
            state.settings.me.support_agent_type == "Admin"
              ? null
              : state.settings.me.support_group_id,
        }),
      });
    }
    if (!state.searching && !state.filter.value) {
      dispatch({ type: "set_current_page", payload });
      dispatch({
        type: "set_current_tasks",
        payload: await API.getTasksByView({ view: state.activeView, page: payload }),
      });
    }
    setTimeout(() => {
      dispatch({ type: "set_view_loading", payload: false });
    }, 600);
  };

  function renderPaginatedTable() {
    const currentTasks = state.searching ? state.query.results : state.tasks;
    const totalPages = state.searching ? state.query.totalPages : state.totalPages;
    const currentPage = state.searching ? state.query.currentPage : state.currentPage;

    const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = React.useState(config);
      const sortedItems = React.useMemo(() => {
        let sortableItems = [...items];
        if (sortConfig !== null) {
          sortableItems.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
              return sortConfig.direction === "ascending" ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
              return sortConfig.direction === "ascending" ? 1 : -1;
            }
            return 0;
          });
        }
        return sortableItems;
      }, [items, sortConfig]);
      const requestSort = (key) => {
        let direction = "ascending";
        if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
          direction = "descending";
        }
        setSortConfig({ key, direction });
      };
      return { items: sortedItems, requestSort, sortConfig };
    };

    const TasksTable = (props) => {
      const { items, requestSort, sortConfig } = useSortableData(props.tasks);
      const getClassNamesFor = (name) => {
        if (!sortConfig) {
          return;
        }
        return sortConfig.key === name ? sortConfig.direction : undefined;
      };
      return (
        <Table
          headers={[
            ...CONST.TABLE_HEADERS.map((i) => (
              <th key={i.name} id={i.label.toLowerCase().replace(" ", "_")}>
                <span
                  onClick={() => {
                    if (i.name == "label") {
                      requestSort("id") && getClassNamesFor("id");
                    }
                    i.filterable != true &&
                      i.name !== "priority" &&
                      requestSort(i.name) &&
                      getClassNamesFor(i.name);
                  }}
                >
                  {i.name == "label" ? (
                    <>
                      <MdSort className="th-sort" />
                      {i.label} ID
                    </>
                  ) : (
                    i.label
                  )}
                </span>

                {i.filterable == true && <TaskFieldFilter name={i.label} />}
              </th>
            )),
          ]}
          children={items.map((task) => (
            <TableRow
              taskHandler={(val) => {
                taskClickHandler(val);
              }}
              key={task.id}
              data={task}
            />
          ))}
        />
      );
    };

    return (
      <>
        <Pagination
          totalPages={totalPages}
          tasksShowing={currentTasks.length}
          totalTasks={state.searching ? state.query.totalTasks : state.totalTasks}
          page={currentPage}
          pageHandler={(num) => pageClickHandler(num)}
        />
        {state.isViewLoading && (
          <div style={{ minHeight: "95vh" }}>
            <Loading message={"Fetching Tasks..."} />
          </div>
        )}
        {!state.isViewLoading && <TasksTable tasks={currentTasks} />}
        {(state.totalTasks !== 0 || (state.searching && state.query.totalTasks !== 0)) && (
          <Pagination
            totalPages={totalPages}
            tasksShowing={currentTasks.length}
            totalTasks={state.searching ? state.query.totalTasks : state.totalTasks}
            page={currentPage}
            pageHandler={(num) => pageClickHandler(num)}
          />
        )}
      </>
    );
  }

  const SideBar = () => {
    let taskFilters = state.appName == 'specialists' ? CONST.SPECIALIST_FILTERS : CONST.DEFAULT_FILTERS;
    return (
      <Col md={3} lg={2} sm={12} style={{ padding: "8px" }}>
        <ListGroup as="ul">
          <ListGroup.Item as="li" className="filter">
            <label>
              <MdSort className="th-sort" />
              SORT BY TASK TYPE
            </label>
            <div className="filter-container">
              <Select
                onChange={(event) => {
                  onFilterChange(event);
                }}
                placeholder="Filter Tasks"
                style={{ color: "black", background: "none !important", height: "42px" }}
                value={state.searching ? "" : state.filter || taskType }
                options={!state.searching ? taskFilters : []}
              />
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            as="li"
            className={state.activeView == "all_open_tasks" ? "active" : null}
            action
            onClick={() => {
              onViewChange("all_open_tasks");
            }}
          >
            All Open Tasks
            <CountBadge count={state.counts.all_open_tasks} />
          </ListGroup.Item>
          <ListGroup.Item
            className={state.activeView == "my_tasks" ? "active" : null}
            action
            as="li"
            onClick={(e) => {
              onViewChange("my_tasks");
            }}
          >
            <MdInbox className="views-icon " />
            My Tasks
            <CountBadge count={state.counts.my_tasks} />
          </ListGroup.Item>
          <ListGroup.Item
            className={state.activeView == "my_sent_tasks" ? "active" : null}
            action
            as="li"
            onClick={(e) => {
              onViewChange("my_sent_tasks");
            }}
          >
            <MdOutbox className="views-icon" />
            My Sent Tasks
            <CountBadge count={state.counts.my_sent_tasks} />
          </ListGroup.Item>
          <ListGroup.Item
            className={state.activeView == "on_hold_tasks" ? "active" : null}
            action
            as="li"
            onClick={(e) => {
              onViewChange("on_hold_tasks");
            }}
          >
            On Hold Tasks
            <CountBadge count={state.counts.on_hold_tasks} />
          </ListGroup.Item>{" "}
          <ListGroup.Item
            className={state.activeView == "closed_tasks" ? "active" : null}
            action
            as="li"
            onClick={(e) => {
              onViewChange("closed_tasks");
              // dispatch({ type: "set_view_closed" });
            }}
          >
            Closed Tasks
            <CountBadge count={state.counts.closed_tasks} />
          </ListGroup.Item>
          {state.settings && state.settings.me && state.settings.me.support_agent_type == "Admin" && (
            <>
              <hr />
              <ListGroup.Item
                className={
                  state.counts.voicemail_calls == 0
                    ? "disabled"
                    : state.activeView == "voicemail_calls"
                    ? "active"
                    : null
                }
                action
                as="li"
                onClick={(e) => {
                  let option = CONST.OTHER_TASK_FILTERS.find((el) => el['task_type'] == 'voicemail_calls');;
                  onFilterChange(option);
                }}
              >
                <MdAddCall className="calls-icon" style={{ transform: "scaleX(-1)" }} />
                Voicemail Calls
                <CountBadge count={state.counts.voicemail_calls} />
              </ListGroup.Item>{" "}
              <ListGroup.Item
                className={
                  state.counts.abandoned_calls == 0
                    ? "disabled"
                    : state.activeView == "abandoned_calls"
                    ? "active"
                    : null
                }
                action
                as="li"
                onClick={(e) => {
                  let option = CONST.OTHER_TASK_FILTERS.find((el) => el['task_type'] == 'abandoned_calls');;
                  onFilterChange(option);
                }}
              >
                <FaPhoneSlash className="calls-icon" style={{ transform: "rotate(180deg)" }} />
                Abandoned Calls
                <CountBadge count={state.counts.abandoned_calls} />
              </ListGroup.Item>
              <ListGroup.Item
                className={
                  state.counts.on_hold_calls == 0
                    ? "disabled"
                    : state.activeView == "on_hold_calls"
                    ? "active"
                    : null
                }
                action
                as="li"
                onClick={(e) => {
                  onViewChange("on_hold_calls");
                }}
              >
                On Hold Calls
                <CountBadge count={state.counts.on_hold_calls} />
              </ListGroup.Item>
              <ListGroup.Item
                className={
                  state.counts.closed_calls == 0
                    ? "disabled"
                    : state.activeView == "closed_calls"
                    ? "active"
                    : null
                }
                action
                as="li"
                onClick={(e) => {
                  onViewChange("closed_calls");
                }}
              >
                Closed Calls
                <CountBadge count={state.counts.closed_calls} />
              </ListGroup.Item>
            </>
          )}
        </ListGroup>
      </Col>
    );
  };

  if (settings.tags == undefined) {
    return (<>
      <Loading message={"Fetching Tasks..."} />
    </>);
  }

  return (
    <>
      {state.isLoading && <Loading message={"Loading Dashboard..."} />}
      {!state.isLoading && !state.isTaskSelected && (
        <>
          <div className="container tasks">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row className="tasks-search-row">
                <Col md={2}>
                  <div className="me">
                    <div className="dashboard-avatar">
                      <MdAccountCircle />
                    </div>
                    <div className="logged-in">
                      <span id="from">You are currently logged in as </span>
                      <br />
                      <b className="secondary">
                        <i>{state.settings && state.settings.me && state.settings.me.name} </i> {state.settings && state.settings.me && state.settings.me.support_group}
                      </b>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={10}>
                  <Row>
                    <Col md={7}>
                      <div className="i-flex mb20 search">
                        <MdSearch className="search-tasks-icon" id="left" />
                        <div className={"flex search-tasks"}>
                          <input
                            placeholder="Search tasks"
                            id={state.searching ? "active" : null}
                            className="search-tasks "
                            ref={queryRef}
                            value={searchTerm}
                            onChange={(e) => {
                              let taskTypeUrlString = taskType ? taskType['task_type'] : null;
                              setTaskParamsUrl(tagValues, tagFilterType, taskStatusFilter, e.target.value, taskTypeUrlString);
                              setSearchTerm(e.target.value);
                              dispatch({ type: "set_searching_tasks", payload: false });
                            }}
                          />
                        </div>

                        { state.searching && (<>
                          <div className="px2 mt2">
                            <select
                              id="task-status-filter-selector"
                              ref={statusRef}
                              value={taskStatusFilter}
                              onChange={(e) => {
                                let taskTypeString = taskType ? taskType['task_type'] : null;
                                let appointmentRequestStatus = taskType ? taskType['appointment_request_status'] : null;
                                setTaskStatusFilter(e.target.value);
                                setTaskParamsUrl(tagValues, tagFilterType, e.target.value, label, taskTypeString, appointmentRequestStatus);
                                dispatch({ type: "set_searching_tasks", payload: false });
                              }}
                            >
                              <option value="">-Select Status-</option>
                              <option value="open">Showing Open Tasks</option>
                              <option value="closed">Showing Closed Tasks</option>
                            </select>
                          </div>
                        </>)}
                      </div>
                      <div className="search-results">
                        {state.searching && (
                          <>
                            Found { state.query.totalTasks } tasks matching your search
                            <a style={{ marginLeft: '15px' }} onClick={(el) => {
                                setTaskParamsUrl([], null, null, null, null);
                                prevView ? onViewChange(prevView) : onViewChange("all_open_tasks");
                              }}
                              className='red-text bold'
                            >
                              <i className='fa fa-times' />
                            </a>
                            <br />
                            { state.query.tagsSearched && state.query.tagsSearched.length > 0 && (<>
                                Tags: { state.query.tagsSearched.join(', ') }
                              </>)
                            }
                            { taskType && (<>
                                Type: <b>{ taskType['label'] }</b>
                              </>)
                            }
                          </>) }
                      </div>
                    </Col>

                    <Col md={5}>
                      <div className="sort-tags">
                        <Select
                          id={'tag-filter-type'}
                          onChange={(el) => {
                            setTagFilterType(el.value);
                            !prevView && setPrevView(state.activeView);
                            dispatch({ type: "set_current_sort_tags" });
                          }}
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: '100px',
                              height: '50px'
                            }),
                          }}
                          values={tagFilterType}
                          placeholder="Match All Tags"
                          options={
                            [ {value: 'match_all', label: 'Match All'}, {value: 'any', label: "Match Any"}]
                          }
                          name={'tag-filter-type'}
                        />
                        <FaTag className="tag-icon" />
                        <Select
                          id={'tag-filter-container'}
                          ref={tagsRef}
                          values={tagValues}
                          selected={tagValues}
                          placeholder="Filter by tags"
                          options={[
                            ...settings.tags.map((i) => {
                              return { value: i, label: i.replaceAll("-", " ") };
                            }),
                          ].concat([
                            ...settings.support_agent_initials_tags.map((i) => {
                              return { value: i, label: i.replaceAll("-", " ") };
                            }),
                          ])}
                          onChange={(e) => {
                            if (!!e.length > 0) {
                              let tagValues = e.map((i) => i.value);
                              setTagValues(tagValues);
                              !prevView && setPrevView(state.activeView);
                            } else {
                              setTaskParamsUrl([], null, null, null);
                              prevView ? onViewChange(prevView) : onViewChange("all_open_tasks");
                            }
                            dispatch({ type: "set_current_sort_tags" });
                          }}
                          isMulti
                          isClearable={true}
                          name="task-tags"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <SideBar />
                <Col sm={12} md={9} lg={10}>
                  {renderPaginatedTable()}
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </>
      )}
    </>
  );
};

export default Tasks;
